<!--
  @修改人: 谢汉 
  @修改时间：2019-01-04
  @修改描述：修改页面名称 --- 告警中心
  @版本:v2.0.00
  ------------
  @description 告警走势图
  @date 2018/11/21
-->
<template>
  <div class="alarmTrend__content">
    <div class="alarmTrend__card mb-base" v-for="(val,i) in siteData" :key="i">
      <div v-show="val.length!==0" class="alarmTrend__appStatus">{{ $t('alarmTrend.appOnlineStatus') }} ：{{ siteList[i] }}</div>
      <ul v-show="val.length!==0">
        <li class="app-status-wrap"
          :class="{ rotate180: item.transitionChange,
          'status-error': item.status ==='error',
          'status-warning': item.status ==='warning',
          'default-bg': item.transitionChange}"
          @click="e_checkGroup(i,index,item)"
          @mouseenter="checkStatus(i,index,item)"
          @mouseleave="leaveStatus(i,index)"
          v-for="(item, index) in val" 
          :key="index">
          <div class="app-status-text" :class="{ rotate180: item.transitionChange }">
            <div v-if="item.textChange">
              <span v-text="item.backApp"></span>
              <span v-text="item.backNode"></span>
            </div>
            <div v-else v-text="item.front"></div>
          </div>
        </li>
      </ul>
    </div>
    <el-row :gutter="20" justify="space-between">
      <el-col :span="12" class="col-height">
        <alarm-table 
          :table-list="saasList"
          :table-info="saasTable"
          @prevpage="saasPrevPage"
          @nextpage="saasNextPage"></alarm-table>
      </el-col>
      <el-col :span="12" class="col-height">
        <alarm-table 
          :table-list="opsList"
          :table-info="opsTable"
          @prevpage="opsPrevPage"
          @nextpage="opsNextPage"></alarm-table>
      </el-col>
      <el-col :span="12" class="col-height">
        <alarm-table 
          :table-list="zabixMinList"
          :table-info="zabixTable"
          alarm-type = "2"
          @prevpage="zabixPrevPage"
          @nextpage="zabixNextPage"></alarm-table>
      </el-col>
    </el-row>
    <div :style="chartStyle" class="mt-base">
      <div class="alarm-chart-title" v-text="'SAAS' + $t('alarmTrend.alarmTrendChart')"></div>
      <el-popover
        placement="bottom-end"
        width="450"
        trigger="click"
        v-model="timePopperVis">
        <span 
          v-for="item in timeList" 
          class="choosen-btn mr-base" 
          :key="item"
          v-text="item" 
          @click="chooseTime(item)"></span>
        <div style="margin-top: 4px;">
          <el-date-picker 
            value-format="timestamp" 
            style="width: 180px;" 
            v-model="startTime" 
            type="datetime">
          </el-date-picker>
          <span v-text="$t('alarmTrend.to')"></span>
          <el-date-picker 
            value-format="timestamp" 
            style="width: 180px;" 
            v-model="endTime" 
            type="datetime">
          </el-date-picker>
          <el-button 
            type="primary" 
            v-text="$t('common.search')" 
            @click="searchChartTime"
            v-g-rac="gRac('alarmTrend@confirm')"></el-button>
        </div>
        <span slot="reference" v-text="choosenTime" class="choosen-btn  btn-position" @click="timePopperVis = true"></span>
      </el-popover>
      <chart-base 
        ref="alarmTrend" 
        chart-id="alarmTrend" 
        :chart-data="chartData" 
        :chart-style="chartOpt"></chart-base>
    </div>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import alarmTable from '@/views/component/alarmTrend/alarmTable.vue'
  import chartBase from '@/components/chart/chart-base.vue'
  import alarmTrendBiz from '@/logic/systemDiagram/alarmTrendBiz'
  import SiteListBiz from '@/logic/cmdb/cmdbBiz'
  import ZabbixMonitorBiz from '@/logic/intelligentMonitor/zabbixMonitorBiz'
  import TimeFormat from '@/utils/timeFormat'
  import { extend } from '@/utils/tool'
  import tab from '@/views/layout/components/setTab'
  const TABLE_TIME = 1000 * 60
  const CHART_TIME = 1000 * 60

  export default {
    mixins: [rac],
    data () {
      return {
        saasList: [],
        opsList: [],
        zabixList: [],
        zabixMinList: [],
        saasTable: {
          title: this.$t('alarmTrend.saasAlarm'),
          currentPage: 1,
          totalCount: 0,
          time: ''
        },
        opsTable: {
          title: this.$t('alarmTrend.opsAlarm'),
          currentPage: 1,
          totalCount: 0,
          time: ''
        },
        zabixTable: {
          title: this.$t('alarmTrend.basicAlarm'),
          currentPage: 1,
          totalCount: 0,
          time: ''
        },
        siteList: {},
        zabbixObj: {},
        siteData: {},
        statusTimer: null,
        chartData: {},
        chartOpt: null,
        legendList: [],
        tableTimer: null,
        chartTimer: null,
        timeList: [this.$t('alarmTrend.realTime'), this.$t('alarmTrend.lastWeek')],
        choosenTime: this.$t('alarmTrend.realTime'),
        startTime: '',
        endTime: '',
        timePopperVis: false,
        chartStyle: {
          width: '100%',
          height: '300px',
          position: 'relative'
        }
      }
    },
    components: {
      alarmTable,
      chartBase
    },
    methods: {
      async init () {
        await this.getSiteList()
        await this.getRankCount()
        await this.getZabbixNode()
      },
      randomKey () {
        return Math.random().toString(36).substr(7)
      },
      fillInData (data) {
        let arr = []
        if (data.length > 0) {
          data.map((item) => {
            arr.push({ ...item, key: this.randomKey() })
          })
          arr = arr.length > 5 ? arr.splice(0, 5) : arr
          for (let i = arr.length; i < 5; i++) {
            arr.push({
              rank: '',
              alarmName: '',
              group: '',
              count: '',
              trend: '',
              key: this.randomKey()
            })
          }
        }
        return arr
      },
      getSaasRank () {
        alarmTrendBiz.getRankCount({
          type: '1',
          currentPage: this.saasTable.currentPage,
          perPageCount: 5
        }).then((data) => {
          this.saasTable.currentPage = data.currentPage
          this.saasTable.totalCount = data.totalCount ? data.totalCount : 1
          this.saasList = this.fillInData(data.dataList)
          this.saasTable.time = data.dataList.length > 0 ? TimeFormat.getFormatTime(data.dataList[0].time) : ''
        })
      },
      getOpsRank () {
        alarmTrendBiz.getRankCount({
          type: '2',
          currentPage: this.opsTable.currentPage,
          perPageCount: 5
        }).then((data) => {
          this.opsTable.currentPage = data.currentPage
          this.opsTable.totalCount = data.totalCount ? data.totalCount : 1
          this.opsList = this.fillInData(data.dataList)
          this.opsTable.time = data.dataList.length > 0 ? TimeFormat.getFormatTime(data.dataList[0].time) : ''
        })
      },
      findGroups () {
        alarmTrendBiz.findGroups().then((data) => {
          this.siteData = {}
          Object.keys(data).map((i) => {
            this.siteData[i] = []
            data[i].map((item) => {
              let obj = {}
              let sumApp = Number(item.offline) + Number(item.online)
              let inlineNode = Number(item.nodeCount) - Number(item.offlineNode)
              let status = ''
              if (item.offline >= 1) {
                status = 'error'
              } else if (item.offlineNode > 0) {
                status = 'warning'
              } else {
                status = 'normal'
              }
              obj.front = item.group
              obj.backApp = 'APP : ' + item.offline + '/' + sumApp
              obj.backNode = 'NODE : ' + inlineNode + '/' + item.nodeCount
              obj.transitionChange = false
              obj.textChange = false
              obj.status = status
              this.siteData[i].push(obj)
            })
          })
        })
      },
      getSiteList () {
        SiteListBiz.siteList({perPageCount: 500}).then((data) => {
          data.dataList.map((item) => {
            this.siteList[item.siteCode] = item.name
          })
        }).catch((err) => {
          console.error(err)
        })
      },
      getZabbixNode () {
        ZabbixMonitorBiz.getNode().then((data) => {
          data.map((item) => {
            this.zabbixObj[item.code] = item.name
          })
        }).catch((err) => {
          console.error(err)
        })
      },
      e_checkGroup (i, index, item) {
        this.leaveStatus(i, index)
        this.$router.push({ path: `/home/logComponentManage?siteCode=${i}&group=${item.front}` })
        tab.selectTab('logComponentManage')
      },
      checkStatus (i, index) {
        this.siteData[i][index].transitionChange = true
        this.clearStatus()
        this.statusTimer = setTimeout(() => {
          this.siteData[i].map((item) => {
            item.textChange = false
          })
          this.siteData[i][index].textChange = true
          this.siteData = extend(true, {}, this.siteData)
        }, 300)
      },
      leaveStatus (i, index) {
        this.siteData[i][index].transitionChange = false
        this.clearStatus()
        this.statusTimer = setTimeout(() => {
          this.siteData[i].map((item) => {
            item.textChange = false
          })
          this.siteData = extend(true, {}, this.siteData)
        }, 300)
      },
      clearStatus () {
        clearTimeout(this.statusTimer)
        this.statusTimer = null
      },
      getZabixRank () {
        alarmTrendBiz.geZabixAlarm().then((data) => {
          this.zabixList = []
          Object.keys(data).map((item) => {
            if (data[item] && data[item].length !== 0) {
              data[item].map(d => {
                d.name = this.zabbixObj[item]
                d.time = TimeFormat.getFormatTime(d.time)
                d.age = TimeFormat.millisecondToDate(d.age)
              })
              this.zabixList = this.zabixList.concat(data[item])
            }
          })
          this.zabixList.length > 5 ? this.zabixMinList = this.zabixList.slice(0, 5) : this.zabixMinList = this.zabixList
          this.zabixTable.totalCount = this.zabixList.length ? this.zabixList.length : 1
        })
      },
      saasPrevPage () {
        this.saasTable.currentPage -= 1
        this.getSaasRank()
      },
      saasNextPage () {
        this.saasTable.currentPage += 1
        this.getSaasRank()
      },
      opsPrevPage () {
        this.opsTable.currentPage -= 1
        this.getOpsRank()
      },
      opsNextPage () {
        this.opsTable.currentPage += 1
        this.getOpsRank()
      },
      zabixPrevPage () {
        this.zabixTable.currentPage -= 1
        this.zabixMinList = this.zabixList.slice((this.zabixTable.currentPage - 1) * 5, this.zabixTable.currentPage * 5)
      },
      zabixNextPage () {
        this.zabixTable.currentPage += 1
        let totalPage = Math.ceil(this.zabixList.length / 5)
        this.zabixTable.currentPage === totalPage ? this.zabixMinList = this.zabixList.slice((this.zabixTable.currentPage - 1) * 5) : this.zabixMinList = this.zabixList.slice((this.zabixTable.currentPage - 1) * 5, this.zabixTable.currentPage * 5)
      },
      getRankCount () {
        this.getSaasRank()
        this.getOpsRank()
        this.getZabixRank()
        this.findGroups()
        this.clearTableTimer()
        this.tableTimer = setTimeout(() => {
          if (new Date().getMinutes() % 10 === 0) this.getRankCount()
        }, TABLE_TIME)
      },
      clearTableTimer () {
        clearTimeout(this.tableTimer)
        this.tableTimer = null
      },
      setChartOpt () {
        this.chartOpt = {
          grid: {
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
          },
          legend: {
            type: 'scroll',
            width: '70%',
            top: '4%',
            data: this.legendList
          }
        }
      },
      drawChart (data) {
        let labelMap = {}
        this.legendList.map(item => { labelMap[item] = item })
        this.chartData = {
          rows: data,
          columns: ['time', ...this.legendList],
          formatMap: {
            time: 'TIMELONG'
          },
          labelMap: labelMap,
          seriesStyle: {
            lineStyle: {
              normal: {
                width: 1.6
              }
            },
            symbol: 'emptyCircle'
          }
        }
      },
      translateData2Chart (data) {
        let arr = []
        this.legendList = []
        for (let i in data) {
          let len = arr.length
          this.legendList.push(i)
          if (data[i].length > 0) {
            data[i].map((item, index) => {
              let obj = {}
              obj[item.group] = item.count
              if (!len) {
                obj.time = item.time
                arr.push({ ...obj })
              } else {
                arr[index] = { ...obj, ...arr[index] }
              }
            })
          }
        }
        return arr
      },
      clearChartTimer () {
        clearTimeout(this.chartTimer)
        this.chartTimer = null
      },
      setChartTimer () {
        this.chartTimer = setTimeout(() => {
          if (new Date().getMinutes() % 10 === 0) {
            this.startTime = new Date().getTime() - (86400 * 1000)
            this.endTime = new Date().getTime()
            this.getChartData(this.startTime, this.endTime)
            this.clearChartTimer()
            this.setChartTimer()
          }
        }, CHART_TIME)
      },
      getChartData (startTime, endTime) {
        alarmTrendBiz.get({
          startTime: startTime,
          endTime: endTime
        }).then(data => {
          let arr = this.translateData2Chart(data)
          this.setChartOpt()
          this.$nextTick(() => {
            this.drawChart(arr)
          })
        })
      },
      chooseTime (item) {
        this.clearChartTimer()
        if (item === this.$t('alarmTrend.lastWeek')) {
          this.startTime = new Date().getTime() - (86400 * 1000 * 7)
          this.endTime = new Date().getTime()
        } else if (item === this.$t('alarmTrend.realTime')) {
          this.startTime = new Date().getTime() - (86400 * 1000)
          this.endTime = new Date().getTime()
          this.setChartTimer()
        }
        this.getChartData(this.startTime, this.endTime)
        this.choosenTime = item
        this.timePopperVis = false
      },
      searchChartTime () {
        this.clearChartTimer()
        this.getChartData(this.startTime, this.endTime)
        this.choosenTime = `${TimeFormat.getFormatTime(this.startTime)} 
          ${this.$t('alarmTrend.to')} ${TimeFormat.getFormatTime(this.endTime)}`
        this.timePopperVis = false
      }
    },
    watch: {
      $route (to, from) {
        if (from.name === 'alarmTrend') {
          this.clearTableTimer()
          this.clearChartTimer()
        } else if (to.name === 'alarmTrend') {
          this.getRankCount()
          if (this.choosenTime === this.$t('alarmTrend.realTime')) {
            this.chooseTime(this.$t('alarmTrend.realTime'))
          }
        }
      }
    },
    mounted () {
      const styleObj = {
        height: document.getElementsByClassName('tabView')[0].clientHeight - 290 + 'px'
      }
      this.chartStyle = { ...styleObj, position: 'relative', width: '100%' }
      this.chooseTime(this.$t('alarmTrend.realTime'))
      this.init()
    }
  }
</script>

<style scoped>
  .choosen-btn {
    font-size: 14px;
    color: #3385ff;
    cursor: pointer;
  }
  .btn-position {
    position: absolute;
    z-index: 99;
    right: 10px;
    top: 10px;
  }
  .alarm-chart-title {
    font-weight: bolder;
    font-size: 16px;
    position: absolute;
    z-index: 99;
    left: 10px;
    top: 10px;
  }
  .alarmTrend__content .app-status-wrap {
    width: 200px;
    height: 40px;
    background: #3bdd9e;
    transition: background .9s, transform .9s;
    margin: 4px;
    color: #fff;
    border-radius: 2px;
    font-size: 12px;
    display: inline-block;
  }
  .alarmTrend__content .app-status-text {
    color: #fff;
    height: 40px;
    line-height: 40px;
    transition: transform .9s;
    text-align: center;
    cursor: pointer;
  }
  .alarmTrend__content .app-status-text span {
    padding: 4px;
  }
  .alarmTrend__content .rotate180 {
    transform: rotateX(180deg);
  }
  .alarmTrend__content .status-error {
    background: #fc7d70;
  }
  .alarmTrend__content .status-warning {
    background: #f5b033;
  }
  .alarmTrend__content .default-bg {
    background: #8192a5;
  }
  .alarmTrend__appStatus {
    font-size: 16px;
    font-weight: 700;
  }
</style>